// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../fonts/TCCC-UnityHeadline-Light.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../fonts/TCCC-UnityHeadline-Regular.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../fonts/TCCC-UnityHeadline-Medium.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../fonts/TCCC-UnityHeadline-Bold.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../fonts/TCCC-UnityText-Regular.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../fonts/TCCC-UnityText-Medium.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../fonts/TCCC-UnityText-Bold.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../fonts/TCCC-UnityText-BoldItalic.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("../fonts/Caveat-Bold.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-weight: 400;
  font-family: TCCC-UnityHeadline;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('woff2');
}

@font-face {
  font-weight: 500;
  font-family: TCCC-UnityHeadline;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('woff2');
}

@font-face {
  font-weight: 600;
  font-family: TCCC-UnityHeadline;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format('woff2');
}

@font-face {
  font-weight: 700;
  font-family: TCCC-UnityHeadline;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format('woff2');
}

@font-face {
  font-weight: 800;
  font-family: TCCC-UnityHeadline;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format('woff2');
}

/* !IMPORTANT! in Figma, the definition of font weight 400
is acutally a Regular variant, not Light. In the future if we 
need TCCC-UnityText-Light, add it back and replace all existing 
font-weight: 400 with 500 */

@font-face {
  font-weight: 400;
  font-family: TCCC-UnityText;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format('woff2');
}

@font-face {
  font-weight: 500;
  font-family: TCCC-UnityText;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format('woff2');
}

@font-face {
  font-weight: 600;
  font-family: TCCC-UnityText;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format('woff2');
}

@font-face {
  font-weight: 700;
  font-family: TCCC-UnityText;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format('woff2');
}

@font-face {
  font-weight: 800;
  font-family: TCCC-UnityText;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_6___}) format('woff2');
}

@font-face {
  font-weight: 700;
  font-family: TCCC-UnityTextItalic;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_7___}) format('woff2');
}

@font-face {
  font-weight: 700;
  font-family: Caveat;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_8___}) format('truetype');
}
`, "",{"version":3,"sources":["webpack://./src/assets/css/typography.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,+BAA+B;EAC/B,4DAAmE;AACrE;;AAEA;EACE,gBAAgB;EAChB,+BAA+B;EAC/B,4DAAqE;AACvE;;AAEA;EACE,gBAAgB;EAChB,+BAA+B;EAC/B,4DAAoE;AACtE;;AAEA;EACE,gBAAgB;EAChB,+BAA+B;EAC/B,4DAAoE;AACtE;;AAEA;EACE,gBAAgB;EAChB,+BAA+B;EAC/B,4DAAkE;AACpE;;AAEA;;;2BAG2B;;AAE3B;EACE,gBAAgB;EAChB,2BAA2B;EAC3B,4DAAiE;AACnE;;AAEA;EACE,gBAAgB;EAChB,2BAA2B;EAC3B,4DAAiE;AACnE;;AAEA;EACE,gBAAgB;EAChB,2BAA2B;EAC3B,4DAAgE;AAClE;;AAEA;EACE,gBAAgB;EAChB,2BAA2B;EAC3B,4DAAgE;AAClE;;AAEA;EACE,gBAAgB;EAChB,2BAA2B;EAC3B,4DAA8D;AAChE;;AAEA;EACE,gBAAgB;EAChB,iCAAiC;EACjC,4DAAoE;AACtE;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,+DAAuD;AACzD","sourcesContent":["@font-face {\n  font-weight: 400;\n  font-family: TCCC-UnityHeadline;\n  src: url('../fonts/TCCC-UnityHeadline-Light.woff2') format('woff2');\n}\n\n@font-face {\n  font-weight: 500;\n  font-family: TCCC-UnityHeadline;\n  src: url('../fonts/TCCC-UnityHeadline-Regular.woff2') format('woff2');\n}\n\n@font-face {\n  font-weight: 600;\n  font-family: TCCC-UnityHeadline;\n  src: url('../fonts/TCCC-UnityHeadline-Medium.woff2') format('woff2');\n}\n\n@font-face {\n  font-weight: 700;\n  font-family: TCCC-UnityHeadline;\n  src: url('../fonts/TCCC-UnityHeadline-Medium.woff2') format('woff2');\n}\n\n@font-face {\n  font-weight: 800;\n  font-family: TCCC-UnityHeadline;\n  src: url('../fonts/TCCC-UnityHeadline-Bold.woff2') format('woff2');\n}\n\n/* !IMPORTANT! in Figma, the definition of font weight 400\nis acutally a Regular variant, not Light. In the future if we \nneed TCCC-UnityText-Light, add it back and replace all existing \nfont-weight: 400 with 500 */\n\n@font-face {\n  font-weight: 400;\n  font-family: TCCC-UnityText;\n  src: url('../fonts/TCCC-UnityText-Regular.woff2') format('woff2');\n}\n\n@font-face {\n  font-weight: 500;\n  font-family: TCCC-UnityText;\n  src: url('../fonts/TCCC-UnityText-Regular.woff2') format('woff2');\n}\n\n@font-face {\n  font-weight: 600;\n  font-family: TCCC-UnityText;\n  src: url('../fonts/TCCC-UnityText-Medium.woff2') format('woff2');\n}\n\n@font-face {\n  font-weight: 700;\n  font-family: TCCC-UnityText;\n  src: url('../fonts/TCCC-UnityText-Medium.woff2') format('woff2');\n}\n\n@font-face {\n  font-weight: 800;\n  font-family: TCCC-UnityText;\n  src: url('../fonts/TCCC-UnityText-Bold.woff2') format('woff2');\n}\n\n@font-face {\n  font-weight: 700;\n  font-family: TCCC-UnityTextItalic;\n  src: url('../fonts/TCCC-UnityText-BoldItalic.woff2') format('woff2');\n}\n\n@font-face {\n  font-weight: 700;\n  font-family: Caveat;\n  src: url('../fonts/Caveat-Bold.ttf') format('truetype');\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
